import {
	Component,
	Input,
	OnInit
} from '@angular/core';

import styles from './DownloadDetails.module.less';

@Component({
	selector: 'download-details',
	templateUrl: './DownloadDetails.Component.html',
	standalone: false
})
export class DownloadDetailsComponent implements OnInit {
	@Input() private readonly accountId: string;
	@Input() private readonly fileId: string;
	@Input() private readonly fileDownloadUrl: string;

	public readonly styles = styles;
	public downloadUrl: string;

	public ngOnInit(): void {
		this.downloadUrl = this.fileDownloadUrl ? this.fileDownloadUrl : `/network/accounts/${this.accountId}/downloads/${this.fileId}`;
	}
}
